import { ChangeDetectorRef, Component, HostListener, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { Vendedor } from '../vendedor';
import { VendedorService } from '../vendedor.service';

@Component({
  selector: 'app-vendedor',
  templateUrl: './vendedor.component.html',
  styleUrls: ['./vendedor.component.css']
})
export class VendedorComponent implements OnInit {

  vendedores: Vendedor[]= [];
  vendedorActuliza: Vendedor;
  listaVendedorActulizar: Vendedor[] = [];
  editForm: FormGroup;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  data: Vendedor[] = [];
  previous: any = [];
  isLoadingResults = true;

  constructor(private alertService: AlertService,private api: VendedorService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }

  mensaje(codigo: string) {



    this.api.getVendedor(codigo).subscribe((data: Vendedor[]) => {
      console.log(data);
      data.forEach(item => {

        this.editForm.controls.nombres.setValue(item.nombres);
        this.editForm.controls.cedula.setValue(item.cedula);
        this.editForm.controls.clave.setValue(item.clave);
        this.editForm.controls.estado.setValue(item.estado);
        this.editForm.controls.telefono.setValue(item.telefono);
        this.editForm.controls.id.setValue(item.id);
    
      });





    }, err => {
      console.log(err);
      this.isLoadingResults = false;
    });
    this.mdbModal.show();


  }

  ngOnChanges(changes: SimpleChanges){
    console.log(changes);
}
ngDoCheck(){


}


listarCliente(){

  this.api.getVendedores(localStorage.getItem('id'))
  .subscribe((
    data: Vendedor[]) => {
    this.vendedores = data;
    console.log(this.vendedores);
    this.mdbTable.setDataSource(this.vendedores);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
}


  ngOnInit() {
    this.listarCliente();

    this.editForm = this.formBuilder.group({
      nombres: ['', Validators.required],
      cedula: ['', Validators.required],
      clave: ['', Validators.required],
      telefono: ['', Validators.required],
      estado: ['', Validators.required],
      id: [0, Validators.required]
      
    });


  }
  eliminarCliente(id: number) {
    this.api.eliminarVendedor(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..");
        this.listarCliente();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      } 
      
      );


  }

  agregarCliente() {
    this.editForm = this.formBuilder.group({
      id: [0, Validators.required],
      nombres: ['', Validators.required],
      telefono: ['', Validators.required],
      cedula: ['', Validators.required],
      estado: ['', Validators.required],
      clave: ['', Validators.required]
      
    });

    this.mdbModal.show();
    this.listarCliente();
  }


  actulizarCliente() {
    this.vendedorActuliza = new Vendedor();
    this.vendedorActuliza.nombres = this.editForm.controls.nombres.value;
    this.vendedorActuliza.cedula = this.editForm.controls.cedula.value;
    this.vendedorActuliza.clave = this.editForm.controls.clave.value;
    this.vendedorActuliza.telefono = this.editForm.controls.telefono.value;
    this.vendedorActuliza.estado = this.editForm.controls.estado.value;
    this.vendedorActuliza.id = this.editForm.controls.id.value;
    this.vendedorActuliza.idEmisor=localStorage.getItem('id');
    this.listaVendedorActulizar[0] = this.vendedorActuliza;

    this.api.setActulizarVendedor(this.listaVendedorActulizar).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..");
        this.mdbModal.hide();
        this.listarCliente();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
   


  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(5);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.vendedores = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.vendedores = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

}
